import apiClient from "utils/apiClient";
import { ensureClientId } from "utils/clientBootstrap";
import { bearerGuestToken, ensureGuestSession } from "utils/guestSession";

export const submitDemoRequest = async (payload) => {
  const clientId = String(await ensureClientId() || "").trim();
  if (!clientId) {
    throw new Error("We could not prepare this browser to submit the request. Please try again.");
  }

  const guestSession = await ensureGuestSession();
  const { data } = await apiClient.post(
    "/profile-service/api/v1/demo-requests",
    payload,
    {
      skipAuthContext: true,
      headers: {
        Authorization: bearerGuestToken(guestSession),
        "O-CLIENT-ID": clientId,
        "O-SKIP-WORKSPACE-CONTEXT": "1",
      },
    },
  );
  return data;
};
